module.exports = __webpack_public_path__ + "img/location-map.acad7fbc.svg";